module.exports = __webpack_public_path__ + "static/media/forex_worldwide_footer.9fda294a.png";